import util   from '../../common/AppUtil';

const ServerMode = 0;
const ApiCode = "XNews";

export default {
  getNews: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"shownews");
  },
  getHotNews: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"hotnews");
  },

  /*
  removeRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"del");
  },

  addRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"add");
  },

  saveRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"save");
  },

  getRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"get");
  }
  */
}
  


// WEBPACK FOOTER //
// ./src/api/system/xshownews.js